import React from 'react';
import c from 'classnames';
import LinkListItem from './LinkListItem';

interface Props {
  direction?: 'row' | 'column';
  children: React.ReactNode;
  ariaLabelledBy?: string;
}

type FooterLinkListComponent = React.FC<Props> & {
  Item: typeof LinkListItem
};

const FooterLinkList: FooterLinkListComponent = (props) => {
  const {
    direction = 'row',
    children,
    ariaLabelledBy,
  } = props;

  const className = c('Footer__link-list', `Footer__link-list--${direction}`);

  return (
    <ul
      className={className}
      aria-labelledby={ariaLabelledBy}
    >
      {children}
    </ul>
  );
};

FooterLinkList.Item = LinkListItem;

export default FooterLinkList;
